import { ReactNode } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Footer from "../components/web/Footer";
import Navbar from "../components/web/Navbar";
import Newsletter from "../components/web/common/Newsletter";

export default function PublicLayout({
  title,
  children,
}: {
  title?: string;
  children: ReactNode;
}) {
  return (
    <HelmetProvider>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Navbar />
      <div>{children}</div>
      <Newsletter />
      <Footer />
    </HelmetProvider>
  );
}
